import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ShieldAlert, X, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Decode a non-httpOnly cookie set by the backend (`impersonation_active=<url-encoded label>`).
const readImpersonationCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)impersonation_active=([^;]+)/);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

const ImpersonationBanner = () => {
  const [label, setLabel] = useState(readImpersonationCookie());
  const [stopping, setStopping] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      const next = readImpersonationCookie();
      setLabel((prev) => (prev === next ? prev : next));
    }, 1000);
    return () => clearInterval(id);
  }, []);

  if (!label) return null;

  const handleStop = async () => {
    setStopping(true);
    try {
      await axios.post(`${API_BASE}/auth/stop-impersonating`, {}, { withCredentials: true });
    } catch (e) {
      console.error('Stop impersonation error:', e);
    }
    window.location.href = '/ad-exp3/panel';
  };

  return (
    <div
      data-testid="impersonation-banner"
      title={`Impersonating ${label} — click X to stop`}
      style={{
        position: 'fixed',
        left: 12,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        padding: '10px 6px',
        borderRadius: 9999,
        background: 'rgba(245, 158, 11, 0.95)',
        color: '#451a03',
        boxShadow: '0 4px 14px rgba(0,0,0,0.18)',
        maxWidth: 38,
      }}
    >
      <ShieldAlert className="w-4 h-4" />
      <span
        style={{
          writingMode: 'vertical-rl',
          transform: 'rotate(180deg)',
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: 0.3,
          whiteSpace: 'nowrap',
          maxHeight: 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        Impersonating {label}
      </span>
      <button
        data-testid="stop-impersonating-button"
        onClick={handleStop}
        disabled={stopping}
        aria-label="Stop impersonating"
        title="Stop impersonating"
        style={{
          background: '#451a03',
          color: '#fef3c7',
          borderRadius: 9999,
          width: 22,
          height: 22,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          cursor: stopping ? 'wait' : 'pointer',
          opacity: stopping ? 0.6 : 1,
        }}
      >
        {stopping ? <Loader2 className="w-3 h-3 animate-spin" /> : <X className="w-3 h-3" />}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
